import React, { useMemo } from "react";
import {
  Dialog,
  Pane,
  CrossIcon,
  Button,
  Text,
  InfoSignIcon,
  StarIcon,
  LightbulbIcon,
} from "evergreen-ui";
import { BLOCKING_MODAL } from "../utils/constants";

const defaultConfigValues = {
  title: "",
  hint: "",
  severity: "",
  icon: "",
  hintIcon: "",
};

const BlockingDialog = ({ onClose, open, blockingData }) => {
  const config = useMemo(() => {
    if (!open) {
      return defaultConfigValues;
    }
    if (!blockingData?.hasFeature) {
      return {
        title: BLOCKING_MODAL.feature.title,
        hint: BLOCKING_MODAL.feature.hint,
        icon: <StarIcon size={50} color="#127cba" />,
        hintIcon: <LightbulbIcon size={15} color="grey" />,
      };
    } else if (!blockingData?.hasPermission) {
      return {
        title: BLOCKING_MODAL.permissions.title,
        hint: BLOCKING_MODAL.permissions.hint,
        icon: <InfoSignIcon color="danger" size={50} />,
        hintIcon: <InfoSignIcon size={15} color="grey" />,
      };
    } else {
      return defaultConfigValues;
    }
  }, [blockingData, open]);

  return (
    <Pane>
      <Dialog
        isShown={open}
        onCloseComplete={onClose}
        hasFooter={false}
        hasHeader={false}
      >
        <Pane textAlign="end">
          <Button onClick={onClose}>
            <CrossIcon />
          </Button>
        </Pane>
        <Pane textAlign="center" marginBottom={10}>
          {config.icon}
        </Pane>
        <Pane textAlign="center" marginBottom={10}>
          <Text size={600}>{config.title}</Text>
        </Pane>
        <Pane
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={20}
        >
          {config.hintIcon}
          <Text size={300} fontStyle="italic" marginLeft={5}>
            {config.hint}
          </Text>
        </Pane>
      </Dialog>
    </Pane>
  );
};

export default BlockingDialog;
